import { render, staticRenderFns } from "./SelectedCongressDistrict.vue?vue&type=template&id=0e61b5b4&scoped=true&"
import script from "./SelectedCongressDistrict.vue?vue&type=script&lang=js&"
export * from "./SelectedCongressDistrict.vue?vue&type=script&lang=js&"
import style0 from "./SelectedCongressDistrict.vue?vue&type=style&index=0&id=0e61b5b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e61b5b4",
  null
  
)

export default component.exports